const getMaxAvailable = (item = {}) => {
  //console.log(item)
  if (item.item_type === 'fixed') {
    //NOTE: new items have an undefined items_purchased so we are just setting that to 0 so the math still goes through although it might be okay in that situation for it to just returh item_qty to make it cleaner?
    if (item.items_purchased === undefined) {
      item.items_purchased = 0
    }
    return item.item_qty - item.items_purchased
  } else {
    return item.raffle_qty - item.tickets_purchased
  }
}

export default getMaxAvailable



// WEBPACK FOOTER //
// ./src/utils/getMaxAvailable.js